import { render, staticRenderFns } from "./ModalSupplierInvoices.vue?vue&type=template&id=9babd09a&lang=pug&"
import script from "./ModalSupplierInvoices.vue?vue&type=script&lang=js&"
export * from "./ModalSupplierInvoices.vue?vue&type=script&lang=js&"
import style0 from "./ModalSupplierInvoices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports